URL_SEARCH_PARAMS_ITERATOR